import { useMemo } from "react";
import { Smartphone } from "lucide-react";
import { SectionCard, SectionHeader, KpiChip, ChartCard, MiniPie, MiniBar, pctOf, last6Months, SECTION_ACCENTS } from "./dashboardUi";

const C = SECTION_ACCENTS.customerApp.chart;

export default function CustomerAppSection({ extra, delay }) {
  const ca = extra?.customer_app;
  const insights = useMemo(() => {
    if (!ca) return null;
    const otherLeads = Math.max(0, (ca.leads_total || 0) - (ca.leads_from_app || 0));
    return {
      totalUsers: ca.total_users || 0,
      leadsFromApp: ca.leads_from_app || 0,
      leadsTotal: ca.leads_total || 0,
      appSharePct: pctOf(ca.leads_from_app || 0, ca.leads_total || 0),
      sourceData: [{ name: "Via App", value: ca.leads_from_app || 0 }, { name: "Other Sources", value: otherLeads }],
      trendData: last6Months(ca.signup_by_month || {}),
    };
  }, [ca]);

  if (!insights) return null;

  return (
    <SectionCard accent="customerApp" delay={delay} testid="dashboard-customer-app-section">
      <SectionHeader icon={Smartphone} accent="customerApp" title="Customer App Adoption" subtitle="How many customers have the app installed, and the leads it generates" />
      <div className="flex items-center gap-1 flex-wrap mb-3">
        <KpiChip label="App Users" value={insights.totalUsers} tone="bg-[#4338CA] text-white" testid="kpi-app-users" />
        <KpiChip label="Leads From App" value={insights.leadsFromApp} tone="bg-indigo-50 text-indigo-800" to="/crm/leads" />
        <KpiChip label="Share of All Leads" value={`${insights.appSharePct}%`} to="/crm/leads" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="dashboard-customer-app-charts">
        <ChartCard title="App Signups (6mo)" testid="chart-app-signups"><MiniBar data={insights.trendData} color={C[0]} /></ChartCard>
        <ChartCard title="Leads: App vs Other Sources" testid="chart-app-lead-share"><MiniPie data={insights.sourceData} colors={C} to="/crm/leads" /></ChartCard>
      </div>
    </SectionCard>
  );
}
